module.exports = __webpack_public_path__ + "img/NI.8fd272e5.svg";